import FileUploadHelper from './fileUploadHelper';

const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

// Validation must run before the presign call: the browser -> S3 PUT is direct, so the server
// cannot check size or type.
export const validateFeedbackImage = (file, imageMaxMb) => {
  if (!ALLOWED_TYPES.includes(file?.type)) {
    return { ok: false, errorKey: 'Please attach a JPG, PNG or WebP image.' };
  }
  if (file.size > imageMaxMb * 1024 * 1024) {
    return { ok: false, errorKey: 'That image is larger than {{max}} MB. Please attach a smaller one.' };
  }
  return { ok: true, errorKey: null };
};

// Uploads the raw File (not base64) so uploadFileOnS3 treats it as isImageFile: false and takes
// Content-Type from file.type. Resolves the presigned uuid to send as feedback.image_id.
export const uploadFeedbackScreenshot = async (file, getS3PreSignedUrl) => {
  const fileUploader = new FileUploadHelper(getS3PreSignedUrl);
  const presignedUrlResponse = await fileUploader.getUUIDForLocalFile('original_image', undefined, file.name);
  const presignedData = presignedUrlResponse?.data?.[0];
  await fileUploader.uploadFileOnS3(file, presignedData, false);
  return presignedData?.uuid;
};
